import { validateBooking } from '@cocoonspace/sdk-js/domains/bookings/bookings'
import type { EventCreateRequestType } from '@cocoonspace/sdk-js/types/eventCreateRequestType'
import { useMutation } from '@tanstack/react-query'
import { bookingFindOrCreate } from './use-booking-find-or-create.hook'

interface BookingVisitMutationArgs {
	space: string
	paymentMethod: string
	day: string
	start: string
	end: string
	type?: EventCreateRequestType
}

export const useBookingVisitMutation = () =>
	useMutation(async (data: BookingVisitMutationArgs) => {
		const event = await bookingFindOrCreate({
			space: data.space,
			day: data.day,
			start: data.start,
			end: data.end,
			type: 'visit',
		})

		const validate = await validateBooking(event.booking_id!, {
			payment_method: data.paymentMethod,
			payment: [],
		})

		return {
			validate,
			event,
		}
	})
